import { useTrackingQuery } from '..';
export var useCustomer = function useCustomer() {
  var _useTrackingQuery$dat;

  return ((_useTrackingQuery$dat = useTrackingQuery().data) === null || _useTrackingQuery$dat === void 0 ? void 0 : _useTrackingQuery$dat.customer) || {};
};